import React, { Component } from 'react'

import View from './view'
import { withRouter } from 'react-router-dom'
import { PATH_NAMES } from '../../../common/constants'

export default withRouter(class extends Component {
	constructor(props) {
		super(props)
		
		const delayTotal = 5
		const delayUnit = 1000
		
		this.timeoutDelay = (delayTotal * delayUnit)
		this.intervalDelay = delayUnit

		this.state = {
			count: 5,
		}
	}

	componentDidMount() {
		const {
			history,
		} = this.props

		const counter = setInterval(() => {
			const updatedCount = this.state.count - 1

			if (updatedCount <= 0) {
				clearInterval(counter)
			}

			this.setState({
				count: updatedCount,
			})
		}, this.intervalDelay)

		setTimeout(() => {
			history.push(PATH_NAMES.HOME)
		}, this.timeoutDelay)
	}

	render() {
		return (
			<View {...this.props} count={this.state.count} />
		)
	}
})


// WEBPACK FOOTER //
// ./src/desktop/pages/notfound/index.js